import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { CreditAgreementEffects, creditAgreementReducer } from './store';

@NgModule({
  imports: [
    EffectsModule.forFeature([CreditAgreementEffects]),
    StoreModule.forFeature(`creditAgreement`, creditAgreementReducer)
  ]
})
export class CreditAgreementStateModule {}
